import React, { useEffect, type ReactNode } from "react";

import { Spinner } from "components";
import { useIsFetching, useIsLoaderLine } from "stores/loadingStateStore";
import { useIsProductLoading } from "stores/product";

type InputCardTitleProps = {
  title?: ReactNode;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export const InputCardTitle = ({
  title = null,
  isLoading,
  setIsLoading,
}: InputCardTitleProps) => {
  const isLoaderLine = useIsLoaderLine();
  const isFetching = useIsFetching();
  const isProductLoading = useIsProductLoading();

  // Effect 1: stop loading when loader line and fetching are done
  useEffect(() => {
    if (!isLoaderLine && !isFetching) {
      setIsLoading(false);
    }
  }, [isLoaderLine, isFetching, setIsLoading]);

  // Effect 2: stop loading when store loading finishes
  useEffect(() => {
    if (!isProductLoading && isLoading) {
      setIsLoading(false);
    }
  }, [isLoading, isProductLoading, setIsLoading]);

  if (!title) {
    return;
  }

  return (
    <div className="d-flex align-items-center mb-4">
      <h5 className="me-3 mb-0">{title}</h5>
      {isLoading && <Spinner size="xxs" />}
    </div>
  );
};
